import React, { useEffect, useState } from 'react';

import {
  Grid,
  IconButton,
  Box,
  Badge,
  Dialog,
  Drawer,
  DialogContent,
  DialogContentText,
  Backdrop,
  CircularProgress,
  Typography,
  Link,
  Card,
  CardContent,
} from '@mui/material';
import { ReactComponent as LogoIcon } from '../../assets/Logo.svg';
import NotificationsIcon from '@mui/icons-material/Notifications';
import CloseIcon from '@mui/icons-material/Close';
import HeaderBgr from '../../assets/header_bg.png';
import MediaCard from 'components/Card';
import Phone_HomePage from '../../assets/Phone_HomePage.svg';
import Email_HomePage from '../../assets/Email_HomePage.svg';
import QA_HomePage from '../../assets/QA_HomePage.svg';
import CardSlider from 'components/CardSlider';
import { Image } from 'pure-react-carousel';
import { useAppContext } from 'contexts/AppContext';
import { useThemeContext } from 'contexts/ThemeContext';
import { StylesProvider, createGenerateClassName } from '@mui/styles';
const generateClassName = createGenerateClassName({
  seed: 'NOTI_BUTTON',
});

const useStyles = {
  partner: {
    carouselClassName: {},
    sliderClassName: {
      padding: '0 30px 0 30px !important',
    },
    classNameTrayWrap: {
      overflow: 'hidden',
      textAlign: 'center',
      verticalAlign: 'middle',
    },
    classNameTray: {
      // padding: "10px !important"
    },
    innerClassName: {
      padding: '10px',
    },
  },
};

const styles = {
  iconTabContact: {
    margin: '5px auto',
  },
  headerBgCus: ({ color }) => {
    return {
      maxWidth: '480px',
      width: '100%',
      position: 'fixed',
      top: 0,
      backgroundColor: color,
      height: '50%',
      WebkitMaskImage:
        '-webkit-gradient(linear, left top, left bottom, from(rgba(0,0,0,1)), to(rgba(0,0,0,0)))',
      maskImage: 'linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,0))',
    };
  },
  wrapperContact: {
    display: 'flex',
    left: '0',
    justifyContent: 'space-around',
    flexDirection: 'column',
    width: '33%',
    textDecoration: 'none',
  },
  headerBg: {
    backgroundImage: `url(${HeaderBgr})`,
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed',
    backgroundSize: '100% 50%',
  },
  title: {
    display: 'flex',
    left: '0',
    justifyContent: 'space-around',
    color: '#000',
  },

  gridWrapper: {
    margin: '0 0.5rem',
  },
};

const NotiButton = (props) => {
  const [showNotiDialog, setShowNotiDialog] = useState(false);
  const { homeData, isLoading } = useAppContext();
  const { mainColor } = useThemeContext();
  const { sliders, products, purposes, partners } = homeData;
  const onClose = () => {
    setShowNotiDialog(false);
  };
  const toggleDrawer = (newOpen) => () => {
    setShowNotiDialog(newOpen);
  };
  return (
    <StylesProvider generateClassName={generateClassName}>
      <Drawer
        anchor={'right'}
        open={showNotiDialog}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        PaperProps={{
          sx: { width: '100%', maxWidth: '480px' },
        }}
      >
        <Box role="presentation">
          <IconButton
            aria-label="close"
            onClick={onClose}
            size="size"
            sx={{
              position: 'absolute',
              right: 8,
              top: 0,
              color: 'white',
              zIndex: '9',
            }}
          >
            <CloseIcon />
          </IconButton>
          <div style={styles.headerBgCus({ color: mainColor })}></div>
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 3 }}
            open={isLoading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <Box
            sx={{
              position: 'relative',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '1.4rem',
              textAlign: 'center',
              marginTop: '1rem',
              marginBottom: '0.5rem',
            }}
          >
            Thông tin về Digiin
          </Box>
          <Card elevation={2} sx={{ height: 'auto', m: 1, position: 'relative' }}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <Typography className={'leadTitle'}>DIGIIN là ai?</Typography>
                <Box sx={{ ml: 2 }}>
                  Digiin là nền tảng bảo hiểm số hàng đầu tại Việt Nam. Chúng tôi chuyên cung cấp
                  các giải pháp bảo hiểm số công nghệ cao để Khách hàng trên các Hệ sinh thái: các
                  Ví điện tử, Điểm bán lẻ, Siêu ứng dụng, trang web bán hàng trực tuyến... dễ dàng
                  tiếp cận được các Sản phẩm, và trải nghiệm Dịch vụ Bảo hiểm – Tài chính tốt nhất
                  trên thị trường
                </Box>
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <Typography className={'leadTitle'}>Tại sao lại chọn DIGIIN?</Typography>
              </Grid>

              {purposes &&
                purposes.map((purpose, item) => (
                  <Grid key={item} item xs={6} sm={6} md={6}>
                    <MediaCard
                      title={purpose.title}
                      description={''}
                      imagePath={purpose.image}
                      isSVG
                      isInline
                      imgWidth={'80%'}
                      style={{
                        height: '6rem',
                        backgroundColor: 'rgba(219, 225, 232, 0.3)',
                        alignContent: 'stretch',
                        display: 'flex',
                        alignItems: 'stretch',
                        borderRadius: '5px',
                      }}
                    />
                  </Grid>
                ))}

              <Grid item xs={12} sm={12} md={12}>
                <Typography className={'leadTitle'}>Đối tác</Typography>
              </Grid>

              <Grid item xs={12} sm={12} md={12} style={styles.gridWrapper}>
                <CardSlider
                  customStyle={useStyles.partner}
                  visibleSlides={4}
                  interval={2000}
                  width={200}
                  height={200}
                  isPlaying
                >
                  {partners &&
                    partners.map((partner, index) => (
                      <Image
                        key={index}
                        src={partner.image}
                        style={{ objectFit: 'contain' }}
                        hasMasterSpinner
                      />
                    ))}
                </CardSlider>
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <Typography className={'leadTitle'}>Hỏi đáp & liên hệ</Typography>
              </Grid>

              <Grid item xs={12} sm={12} md={12} style={styles.gridWrapper}>
                <Card>
                  <CardContent>
                    <Typography variant="body2" color="text.secondary">
                      Cần giúp đỡ? Hãy liên lạc bộ phận Chăm sóc dịch vụ của chúng tôi ngay.
                    </Typography>
                    <div
                      style={{
                        position: 'relative',
                        display: 'flex',
                        padding: '5px',
                        justifyContent: 'space-between',
                      }}
                    >
                      <a href="tel:02871061618" style={styles.wrapperContact}>
                        <div style={{ margin: '5px auto' }}>
                          <img src={Phone_HomePage} />
                        </div>
                        <div style={styles.title}>(028) 7106 1618</div>
                      </a>
                      <a href="mailto:hotro@digiin.vn" style={styles.wrapperContact}>
                        <div style={{ margin: '5px auto' }}>
                          <img src={Email_HomePage} />
                        </div>
                        <div style={styles.title}>Email</div>
                      </a>
                      <Link href="/qna" style={styles.wrapperContact} underline="none">
                        <div style={{ margin: '5px auto' }}>
                          <img src={QA_HomePage} />
                        </div>
                        <div style={styles.title}>Hỏi đáp</div>
                      </Link>
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Card>
        </Box>
      </Drawer>
      <IconButton
        onClick={() => {
          setShowNotiDialog(true);
        }}
      >
        <Badge badgeContent={1} color="error">
          <NotificationsIcon sx={{ color: '#fff' }} />
        </Badge>
      </IconButton>
    </StylesProvider>
  );
};
export default NotiButton;
